var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("h4", { staticClass: "mt-2 pt-50" }, [_vm._v("My Role Permissions")]),
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", { staticClass: "table table-flush-spacing" }, [
          _c(
            "tbody",
            _vm._l(_vm.permissions, function (item) {
              return _c("tr", { key: item }, [
                _c("td", { staticClass: "text-nowrap fw-bolder" }, [
                  _vm._v(_vm._s(item)),
                ]),
              ])
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }